import { DreamSearchViewerResults } from "@portal/app/_common/types/dreamSearch";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography, { TypographyProps } from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { DreamSearchResultsCarousel } from "@portal/app/health/_components/components/DreamSearchResult/DreamSearchResultsCarousel";
import { kebabCase } from "@portal/app/_common/lib/changeCase";
import { useMixpanel } from "@portal/app/_components/hooks/useMixpanel";
import { MixpanelEventName } from "@portal/app/_common/types/mixpanel";

export const DreamSearchCarousel = ({
  items,
  handleClickSeeMore,
  title = "Recommended for you",
  titleComponent = "h3",
  programHeadingComponent,
  mixpanelEventMap,
}: {
  items: DreamSearchViewerResults;
  handleClickSeeMore: () => void;
  title?: string;
  titleComponent?: "h3" | "span";
  programHeadingComponent?: "h3" | "span";
  mixpanelEventMap: {
    cardClicked: MixpanelEventName;
    seeMoreClicked: MixpanelEventName;
  };
}) => {
  const analytics = useMixpanel();
  return (
    <DreamSearchCarouselContainer data-testid={kebabCase(title)}>
      <CarouselHeaderContainer>
        <CarouselHeader component={titleComponent} variant="new_h3">
          {title}
        </CarouselHeader>
        <Button
          size="small"
          variant="outlined"
          onClick={async () => {
            await analytics.track(mixpanelEventMap.seeMoreClicked);
            handleClickSeeMore();
          }}
          data-testid="see-more-recommended"
        >
          See more
        </Button>
      </CarouselHeaderContainer>
      <DreamSearchResultsCarousel
        items={items}
        eventName={mixpanelEventMap.cardClicked}
        programHeadingComponent={programHeadingComponent}
      />
    </DreamSearchCarouselContainer>
  );
};

export const DreamSearchCarouselContainer = styled(Box)`
  background: ${({ theme }) => theme.palette.dream.grayLighter};
  padding: 1rem 0;
  width: 100%;

  .carousel_slider {
    margin-top: 0.5rem;
    padding-left: 1rem;
  }
`;

const CarouselHeaderContainer = styled(Box)`
  margin: 0 auto 1rem auto;
  width: 50rem;
  max-width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 0 1rem;
    margin: 0 auto;
  }
`;
const CarouselHeader = styled(Typography)<TypographyProps>`
  flex: 1 1;
  font-size: 1.5rem;
  margin: 0;
`;
